import React from 'react';
import { withContent } from '../../hoc/withContext';
import { IContext } from '../../types';
import {
  PartnerGameDescription,
  PartnerGamesSection, PartnerGamesTextContainer,
  PartnerGamesTitle,
  PartnerGameTag,
  PartnerGameTagContainer, ViewCloudGamesContainer, ImageContainer
} from './PartnerGamesStyle';
import CloudItem from './CloudItem';
import PictureImage from '../utils/Picture';

const PartnerGamesContainer = ({ context }: IContext) => {
  return (
    <PartnerGamesSection>
      <ImageContainer side={'right'}>
        <PictureImage
          images={[{
            imageName: 'partnerBannerLeftSide_desktop',
            minWidth: 1500
          }, {
            imageName: 'partnerBannerLeftSide_tablet',
            minWidth: 721
          }, {
            imageName: 'partnerBannerLeftSide_mobile',
            minWidth: 0
          }
          ]}
          containsWebp={false}
          extension="png"
          altText={context.partnerGames.leftImageAlt}
          className={['']}
        />
      </ImageContainer>
      <PartnerGamesTextContainer>
        <PartnerGamesTitle dangerouslySetInnerHTML={{ __html: context.partnerGames.title }} />
        <PartnerGameTagContainer>
          {context.partnerGames.tag.map((tag, index) =>
            <PartnerGameTag tagColor={tag.color} firstTag={index === 0} key={'tag-' + tag.text}>
              {tag.text}
            </PartnerGameTag>
          )}
        </PartnerGameTagContainer>
          {/*Cloud platforms and text to be initialised when the anywhereAvailability window variable is ready*/}
          {window.anywhereAvailability &&
             <>
                  <PartnerGameDescription>{
                      (window.anywhereAvailability.luna_available && window.anywhereAvailability.stadia_available) ?
                       context.partnerGames.stadiaLunaDescription : context.partnerGames.stadiaDescription }
                  </PartnerGameDescription>
                      <ViewCloudGamesContainer singleCloudItem={!(window.anywhereAvailability.luna_available && window.anywhereAvailability.stadia_available)}>
                      {context.partnerGames.cloud.filter(cloudItem => window.anywhereAvailability[cloudItem.windowKey]).map((cloudItem, index) =>
                          <CloudItem cloudItem={cloudItem}
                                     singleItem={context.partnerGames.cloud.filter(cloudItem =>  window.anywhereAvailability[cloudItem.windowKey]).length == 1}
                                     firstItem={index === 0}
                                     key={'cloud-item-' + cloudItem.svg} />
                      )}
                  </ViewCloudGamesContainer>
            </>
          }
      </PartnerGamesTextContainer>
      <ImageContainer side={"left"}>
        <PictureImage
          images={[{
            imageName: 'partnerBannerRightSide_desktop',
            minWidth: 1500
          }, {
            imageName: 'partnerBannerRightSide_tablet',
            minWidth: 721
          }, {
            imageName: 'partnerBannerRightSide_mobile',
            minWidth: 0
          }
          ]}
          extension="png"
          altText={context.partnerGames.rightImageAlt}
          className={['']}
          containsWebp={false}
        />
      </ImageContainer>
    </PartnerGamesSection>
  );
};

export default withContent(PartnerGamesContainer);